module.exports = __webpack_public_path__ + "img/commandeSection1.52cbf751.png";